import { Users, Bike, BadgeCheck } from "lucide-react";
import { ZOOMY } from "@/constants/zoomyIds";

const STATS = [
  { label: "EV bikes sold", value: "50+", icon: Bike, sub: "across our dealership network" },
  { label: "Riders served", value: "100+", icon: Users, sub: "monthly active rentals" },
  { label: "Fleet uptime", value: "88%", icon: BadgeCheck, sub: "fleet-wide service SLA" },
];

const MARQUEE = [
  "किफायते पे EV", "Rent · Buy · Partner", "Battery Swap", "Doorstep Delivery",
  "Zero Fuel", "GPS Tracked", "Same-day RC", "0% Down Plans",
];

export const Stats = () => {
  return (
    <section id="stats" data-testid={ZOOMY.statsSection} className="relative py-24 sm:py-32 border-t border-white/5">
      {/* Marquee strip */}
      <div className="absolute top-0 inset-x-0 border-y border-lime-400/30 bg-lime-400 text-black overflow-hidden">
        <div className="flex whitespace-nowrap marquee-track py-3">
          {[...MARQUEE, ...MARQUEE, ...MARQUEE].map((t, i) => (
            <span
              key={i}
              className="font-display text-base sm:text-lg font-bold uppercase tracking-tight px-6 flex items-center gap-6"
            >
              {t}
              <span className="text-black/50">✦</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-24">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="font-mono text-xs uppercase tracking-[0.28em] text-lime-400 mb-5">
              // 02 — Built on numbers
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95]">
              Not a pitch. <br />
              A working <span className="text-lime-400">balance sheet</span>.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-6">
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed">
              Zoomy started as a single-city EV rental experiment. Today we operate a
              vertically integrated mobility business — rentals, retail dealership and
              service — generating consistent unit-level profitability across every
              vehicle we put on the road.
            </p>
          </div>
        </div>

        {/* Bento stats grid — sharp borders */}
        <div className="grid grid-cols-1 md:grid-cols-3 border border-white/10">
          {STATS.map((s, i) => {
            const Icon = s.icon;
            const isLast = i === STATS.length - 1;
            return (
              <div
                key={s.label}
                className={`group relative p-7 sm:p-10 border-white/10 ${
                  !isLast ? "border-b md:border-b-0 md:border-r" : ""
                } hover:bg-lime-400 transition-colors duration-300`}
                data-testid={`stat-${i}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <Icon
                    className="w-6 h-6 text-lime-400 group-hover:text-black transition-colors"
                    strokeWidth={1.5}
                  />
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 group-hover:text-black/60 transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <div className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white group-hover:text-black transition-colors">
                  {s.value}
                </div>
                <div className="mt-3 text-sm font-semibold text-white group-hover:text-black uppercase tracking-wider transition-colors">
                  {s.label}
                </div>
                <div className="mt-2 text-xs text-slate-500 group-hover:text-black/70 transition-colors">
                  {s.sub}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
